import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, filter, startWith } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { VersionsViewService, VersionsService } from '@app/services/app/versions.service';

import { WebsocketService } from '@core/services/websocket/websocket.service';

import * as Objects from '@core/objects';
import { TitleService } from '@core/services/title.service';
import { AppService } from '@app/services/app/app.service';
import { AppRouterService } from '@app/services/app/router.service';


@Component({
    selector: 'version-details-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class VersionsDetailsMainComponent implements OnInit, OnDestroy {
    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;
    public readonly STATUS_NOT_FOUND = 3;
    public readonly STATUS_ERROR = 4;

    public version: Objects.Version = null;
    protected versionId: number;
    public breadcrumbContext: string = 'ARTWORK';

    public pageStatus:number = this.STATUS_LOADING;
    public statusHeader: number = this.STATUS_LOADING;
    // Enabled redirection to handle the new requirement
    private allowRedirect: boolean = true; 

    // protected urlSubscriptor: Subscription;
    protected versionSubscriptor: Subscription;
    protected errorSubscriptor: Subscription;
    protected errorHeaderSubscriptor: Subscription;
    protected wsSubscription: any = null;
    protected appSubscriptor: Subscription;
    protected subs = new Subscription();

    constructor(private title: TitleService,
        public app: AppService,
        private router: Router,
        private versionsSrv: VersionsService,
        private activeRoute: ActivatedRoute,
        private viewVersionsSrv: VersionsViewService, 
        public websocket: WebsocketService,
        private appRouter: AppRouterService
    ) { }

    ngOnInit() {
        this.title.set("Version ....");
        // HERE LOAD version status Access on Library Store. 
        // this.librarySrv.loadVersionsStatusAccess();

        // get the version id and load it in the store.
        // this.urlSubscriptor = this.activeRoute.params.subscribe((params: any) => {
        //     // Get the 'vid' parameter from the route and cast to number
        //     const routeVid = params.vid as number;
        //     if(routeVid){
        //         this.pageStatus = this.STATUS_LOADING;
        //         this.versionsSrv.getProject$({ id: routeVid} as Objects.Version).subscribe((originalProject: Objects.Request) => {
        //             if (originalProject != null)
        //                 this.appRouter.navigate('/projects/' + originalProject.id + '/versions/' + routeVid);
        //         });
        //         // this.viewVersionsSrv.clear(); // must clear to avoid interference on data at library navigation other versions
        //         // this.viewVersionsSrv.load(routeVid);
        //         // this.versionId = routeVid;
        //     }


        // });

        this.subs.add(
            this.router.events.pipe(
                filter(e => e instanceof NavigationEnd),
                startWith(null)
            ).subscribe(() => {
                const child = this.activeRoute.firstChild;
                const isPureRoute = child === null;
                // Detect if the active child route is the 'files' preview
                const isFileRoute = child?.snapshot.url[0]?.path === 'files';
                // Collect all params (vid, fid, etc.) from the route tree
                const allParams = this.collectParams(this.activeRoute.snapshot.root);

                if (isPureRoute || isFileRoute) {
                    if (this.allowRedirect) {
                        this.breadcrumbContext = 'PROJECT';
                        this.handleRedirect(allParams);
                    }
                } else {
                    this.viewVersionsSrv.clear(); // must clear to avoid interference on data at library navigation other versions
                    if (allParams.vid) {
                        this.breadcrumbContext = 'ARTWORK';
                        this.pageStatus = this.STATUS_LOADING;
                        this.viewVersionsSrv.load(allParams.vid);
                        this.versionId = allParams.vid;
                        this.pageStatus = this.STATUS_DONE;
                    } else {
                        this.pageStatus = this.STATUS_NOT_FOUND;    
                    }
                }
            })
        );

        // TODO 16/12/2025 clean all the unused code
        // get the version
        // this.versionSubscriptor = this.viewVersionsSrv.selectVersion().subscribe((version: Objects.Version) =>
        // {
        //     if(version == null) 
        //         return;
        //     this.version = version;
        //     this.title.set("Version #"+this.version.id);
        //     this.pageStatus = this.STATUS_DONE;
            
        // });

        // this.appSubscriptor = this.app.getSession().subscribe( (session: any) => {
        //     if(session == null)
        //         return;

        // });

        // this.errorSubscriptor = this.viewVersionsSrv.selectError('load_version').subscribe((error: HttpErrorResponse) => this.setError(error));
        // this.errorHeaderSubscriptor = this.viewVersionsSrv.selectError('load_header').subscribe((error: HttpErrorResponse) => this.setHeaderError(error));

        
    }

    private handleRedirect(params: any = {}){
        if (params.vid) {
            this.versionsSrv.getProject$({ id: +params.vid } as Objects.Version).subscribe((originalProject: Objects.Request) => {
                if (originalProject != null) {
                    const navPath = ['/projects', originalProject.id, 'versions', params.vid];
                    
                    // If a file ID is present, append it to the navigation path
                    if (params.fid) {
                        navPath.push('files', params.fid);
                    }

                    this.router.navigate(navPath);
                }
            });
        }
    }
    /**
     * Helper to collect parameters from the entire active route tree
     */
    private collectParams(route: any, params: any = {}): any {
        if (route.params) params = { ...params, ...route.params };
        if (route.firstChild) return this.collectParams(route.firstChild, params);
        return params;
    }

    ngOnDestroy() {
        // this.urlSubscriptor.unsubscribe();
        // this.versionSubscriptor.unsubscribe();
        // this.errorSubscriptor.unsubscribe();
        // this.errorHeaderSubscriptor.unsubscribe();
        // this.appSubscriptor.unsubscribe();
        // if(this.wsSubscription)
        //     this.wsSubscription.unsubscribe();
        this.viewVersionsSrv.clear();
        this.subs.unsubscribe();
    }

    //TODO SET ERRORS
    // protected setError(error: HttpErrorResponse) {

    //     // console.log("errrroooooorrrr--->", error);
    //     if(error == null)
    //         return;

    //     switch(error.status) {
    //         case 500:
    //             this.pageStatus = this.STATUS_ERROR;
    //             break;
    //         case 404:
    //             this.pageStatus = this.STATUS_NOT_FOUND;
    //             break;
    //         case 403:
    //         case 401:
    //             this.pageStatus = this.STATUS_NOT_ALLOWED;
    //             break;
    //     }
    // }

    // protected setHeaderError(error: HttpErrorResponse) {

    //     // console.log("errrroooooorrrr--->", error);
    //     if(error == null)
    //         return;

    //     switch(error.status) {
    //         case 500:
    //             this.statusHeader = this.STATUS_ERROR;
    //             break;
    //         case 404:
    //             this.statusHeader = this.STATUS_NOT_FOUND;
    //             break;
    //         case 403:
    //             this.statusHeader = this.STATUS_NOT_ALLOWED;
    //             break;
    //     }
    // }

}
